// Deployment trigger: 2026-04-24
import { auth } from "../firebase";

interface SetCredentialsParams {
  targetEmail: string;
  targetUsername?: string;
  apiUsername: string;
  apiPassword: string;
}

/**
 * Stores a workspace user's external-API (myeSalon) credentials via the secure
 * backend endpoint. The password is encrypted server-side and is never written
 * to Firestore in plaintext from the browser.
 */
export const setWorkspaceCredentials = async (params: SetCredentialsParams) => {
  const current = auth.currentUser;
  if (!current) throw new Error("You must be signed in to set credentials.");

  const idToken = await current.getIdToken();

  const response = await fetch("/api/set-credentials", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(params),
  });

  let data: any = {};
  try {
    data = await response.json();
  } catch {
    /* non-JSON error */
  }

  if (!response.ok) {
    throw new Error(data.error || "Failed to store API credentials.");
  }

  return data;
};
